import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import ActionAreaCard from '../ActionAreaCard/ActionAreaCard';
import moneda from '../../../../assets/moneda.png'
import fin from '../../../../assets/fin.png'
import llave from '../../../../assets/llave.png'
import { useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import Alerts from '../Alerts/Alerts';
import globspot from '../../../../assets/globspot2.png';
import background from '../../../../assets/backworks.png';


const Third = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [alert, setAlert] = useState({ message: '', severity: 'success' as 'success' | 'error', open: false });
  const showAlert = (message: string, severity: 'success' | 'error') => {
    setAlert({ message, severity, open: true });
  };
  const handleAlertClose = () => {
    setAlert((prevAlert) => ({ ...prevAlert, open: false }));
  };
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  
  return (
    <Box 
    sx={{ 
      marginTop:{xs:'5%',md:'2%'},
      backgroundImage: `url(${background})`,
      backgroundSize: {xs:'600%', md:'100%'},
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative', // Permite posicionar la capa pseudo-elemento correctamente
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255,255,255,0.1)', // Color de superposición con transparencia
        zIndex: 1, // Coloca la capa sobre la imagen de fondo
      }
    }}
  >     
<Typography
  variant="h3"
  align="center"
  sx={{
    marginTop: '2%',
    fontWeight: 'bold',
    fontSize: { xs: '1.2rem', md: '2.5rem' }, // Tamaño ajustado
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px', // Espacio entre el texto y la imagen
  }}
>
  ¿Cómo empezar con
  <Box
    component="img"
    src={globspot}
    alt="Globspot"
    sx={{
      height: { xs: 50, md: 100 }, // Tamaño en móviles y en ordenadores
      width: { xs: 150, md: 300 },
      marginBottom:{xs:'7px', md:'10px'},
      verticalAlign: 'center', // Alinea la imagen con la base del texto
    }}
  />
  ?
  </Typography>
      <Typography variant="h2" align="center" sx={{marginBottom:"2%", fontSize: { xs: '1rem', md: '1.9rem' }}}>
      Sigue estos sencillos pasos y optimiza tu flotilla hoy
      </Typography>
      <Grid
        container
        spacing={{ xs:2, md: 20 }}  
        alignItems="center"
        justifyContent="center"
        sx={{
          marginTop: '3%',
        }}
      >
          <Grid 
            item 
            xs={0}  
            sm={7}  
            md={3} 
          > 
            <ActionAreaCard title="Solicita tu cotización" description='Completa el formulario para recibir una cotización personalizada que incluye nuestro paquete de rastreo satelital y telemetría avanzada.' image={moneda}/>
          </Grid>
          <Grid 
            item 
            xs={0}  
            sm={7}  
            md={3}  
          > 
            <ActionAreaCard title="Recibe tu cupón de Buen Fin" description='Tras completar el formulario, te enviaremos automáticamente un cupón del 20% de descuento. ' image={fin}/>
          </Grid>
          <Grid 
            item 
            xs={0}  
            sm={7}  
            md={3}   
          > 
            <ActionAreaCard title="Instalación y activación" description='Después de confirmar la compra, instalamos el equipo de telemetría y GPS en tu flotilla y te proporcionamos acceso completo a nuestra plataforma.' image={llave}/>
            
          </Grid>
          
      </Grid>
      <Grid item xs={12} textAlign="center" mt={2}>
      <Tooltip title="Cotiza ahora">
        <Button 
          variant="contained"
          color='primary'
          sx={{ borderRadius: '15px', fontSize: { xs: '0.8rem', md: '1rem' }, fontWeight: "bold",alignItems: 'center',marginBottom:'20px',zIndex:2,
          backgroundColor:'rgba(51,194,239,1' }} 
          onClick={handleOpenModal}
        >
          Cotiza ahora
        </Button>
        
      </Tooltip>
      </Grid>
      <CustomModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        showAlert={showAlert}

      />
      <Alerts 
        message={alert.message} 
        severity={alert.severity} 
        open={alert.open} 
        onClose={handleAlertClose} 
      />
    </Box>
  );
};

export default Third;
